var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/FilterCondition/validateValueField.ts";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.string.trim.js";
import * as smApi from '@gmini/sm-api-sdk';
var minLengthValue = 3;
export var validateValueField = function validateValueField(condition, value, options) {
  var _condition$operator, _condition$operator2;

  var isValidatedOperator = ((_condition$operator = condition.operator) === null || _condition$operator === void 0 ? void 0 : _condition$operator.value) === smApi.Filter.FilterCondition.Contain || ((_condition$operator2 = condition.operator) === null || _condition$operator2 === void 0 ? void 0 : _condition$operator2.value) === smApi.Filter.FilterCondition.NotContain;
  var valueIdEqualOption = options.some(function (item) {
    return item === value;
  });

  if (!isValidatedOperator || valueIdEqualOption) {
    return true;
  }

  var isValidLength = value.trim().length >= minLengthValue;
  return isValidLength;
};